"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.discountCodeExists = exports.getTopFiveCampaigns = exports.orderReport = exports.conflictsOfCampaign = exports.releaseNote = exports.insightShop = exports.campaignStatusDetail = exports.dashboardBootstrap = void 0;
const fetchInstance_1 = require("../../../utils/fetchInstance");
/**
* @summary Combined shopInfo + planUsage + shopStorage + dashboardReport + hasAnyOrders in one request — used by the frontend app shell on first load instead of 5 separate parallel requests
*/
const dashboardBootstrap = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/dashboard/bootstrap`, method: 'get'
    });
};
exports.dashboardBootstrap = dashboardBootstrap;
/**
* @summary Get detail of campaigns grouped by status
*/
const campaignStatusDetail = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/dashboard/campaignStatusDetail`, method: 'get'
    });
};
exports.campaignStatusDetail = campaignStatusDetail;
/**
* @summary Get detail of campaigns grouped by status
*/
const insightShop = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/dashboard/insightShop`, method: 'get'
    });
};
exports.insightShop = insightShop;
/**
* @summary Get detail of campaigns grouped by status
*/
const releaseNote = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/dashboard/releaseNote`, method: 'get'
    });
};
exports.releaseNote = releaseNote;
/**
* @summary Get list of Conflicts Of Campaigns
*/
const conflictsOfCampaign = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/dashboard/ConflictsOfCampaign`, method: 'get'
    });
};
exports.conflictsOfCampaign = conflictsOfCampaign;
/**
* @summary Get list of revenue report based on given date the default is last 7 days
*/
const orderReport = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/dashboard/orderReport`, method: 'get',
        params
    });
};
exports.orderReport = orderReport;
/**
* @summary Get top five campaigns
*/
const getTopFiveCampaigns = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/dashboard/topFiveCampaigns`, method: 'get'
    });
};
exports.getTopFiveCampaigns = getTopFiveCampaigns;
/**
* @summary Check if discount code exists
*/
const discountCodeExists = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/dashboard/discountCodeExists`, method: 'get',
        params
    });
};
exports.discountCodeExists = discountCodeExists;
